import { Typography, Box, List, ListItem, ListItemText, ListItemIcon, Checkbox } from '@material-ui/core';
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank } from '@material-ui/icons';
import React from 'react';
import { useCampfireTheme } from '../../../../../../../theme/useCampfireTheme';
import { useFilterStyles } from '../../../../../../../common/filter-fields/FilterClasses';
import {
  IncomingVolunteersFilters,
  statusFilters,
  filterHelperTexts,
  INCOMING_VOLUNTEER_STATUS_FILTER_ENUM,
} from '../filters';

type StatusFilterMobileProps = {
  selectedFilters: IncomingVolunteersFilters;
  setSelectedFilters: (x: IncomingVolunteersFilters) => void;
};

const StatusFilterMobile = ({ selectedFilters, setSelectedFilters }: StatusFilterMobileProps) => {
  const { theme } = useCampfireTheme();
  const classes = useFilterStyles(theme);
  const isStatusFilterSelected = (value: string) => selectedFilters.selectedStatusFilter === value;
  const handleDurationChange = (value: string) =>
    setSelectedFilters({
      ...selectedFilters,
      selectedStatusFilter: value as INCOMING_VOLUNTEER_STATUS_FILTER_ENUM,
    });
  return (
    <Box py={2}>
      <Typography color='textSecondary' variant='body1' gutterBottom>
        {filterHelperTexts.statusFiltersHelperText}
      </Typography>
      <List disablePadding>
        {statusFilters.map((statusFilter) => (
          <ListItem
            key={statusFilter}
            onClick={() => handleDurationChange(statusFilter)}
            disableGutters
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Checkbox
                checked={isStatusFilterSelected(statusFilter)}
                className={classes.checkBox}
                checkedIcon={<CheckBoxIcon color='primary' />}
                size='small'
                icon={<CheckBoxOutlineBlank />}
                disableRipple
              />
            </ListItemIcon>
            <ListItemText>
              <Typography
                variant='body1'
                color='textSecondary'
                style={isStatusFilterSelected(statusFilter) ? { fontWeight: 600 } : { fontWeight: 'normal' }}
              >
                {statusFilter}
              </Typography>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export { StatusFilterMobile };
